import { render, staticRenderFns } from "./ClientNavigator.vue?vue&type=template&id=034052e6&scoped=true"
import script from "./ClientNavigator.vue?vue&type=script&lang=js"
export * from "./ClientNavigator.vue?vue&type=script&lang=js"
import style0 from "./ClientNavigator.vue?vue&type=style&index=0&id=034052e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034052e6",
  null
  
)

export default component.exports